/* Downloads a given blob as file in browser */
export const downloadBlobAsFile = (blobData, fileName, fileType) => {
  // do a basic check if we are in browser
  if (!window || !document) {
    return;
  }

  // convert blob data to url
  const url = window.URL.createObjectURL(new Blob([blobData], { type: fileType }));

  // create a link in the document
  const link = document.createElement('a');
  link.href = url;

  // set the link attribute to download filename
  link.setAttribute('download', fileName);
  document.body.appendChild(link);

  // click on the link and remove it from the document
  link.click();
  link.remove();
};
